// Ladda-style "slide-left" button spinner.
// Add `data-spin` to any <button> or <input type="submit"> to animate on click/submit.

const EASING = 'cubic-bezier(0.175, 0.885, 0.32, 1.275)'
const DURATION = '0.3s'

const CSS = `
[data-spin] {
  position: relative;
  overflow: hidden;
}
[data-spin] .spin-label {
  position: relative;
  display: inline-block;
  left: 0;
  opacity: 1;
  transition: left ${DURATION} ${EASING},
              opacity ${DURATION} ${EASING};
}
[data-spin] .spin-spinner {
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: left ${DURATION} ${EASING},
              opacity ${DURATION} ${EASING};
}
[data-spin].spinning .spin-label {
  left: -100%;
  opacity: 0;
}
[data-spin].spinning .spin-spinner {
  left: 50%;
  opacity: 1;
}
[data-spin].spinning {
  pointer-events: none;
}
`

function injectStyles() {
  const style = document.createElement('style')
  style.textContent = CSS
  document.head.appendChild(style)
}

function setupButton(btn) {
  if (btn.querySelector('.spin-label')) return

  const label = document.createElement('span')
  label.className = 'spin-label'
  while (btn.firstChild) {
    label.appendChild(btn.firstChild)
  }

  const spinner = document.createElement('span')
  spinner.className = 'spin-spinner'
  spinner.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'

  btn.appendChild(label)
  btn.appendChild(spinner)
}

function activate(btn) {
  if (btn.classList.contains('spinning')) return
  setupButton(btn)
  btn.classList.add('spinning')
  btn.disabled = true
}

function init() {
  injectStyles()

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-spin], input[data-spin][type="submit"], a[data-spin]')
    if (!btn) return

    // For buttons inside a form, let the form submit handler handle it.
    // For standalone buttons/links (not in a form), activate immediately.
    if (!btn.form) {
      activate(btn)
    }
  })

  document.addEventListener('submit', (e) => {
    const btn = e.target.querySelector('button[data-spin], input[data-spin][type="submit"]')
    if (btn) {
      activate(btn)
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
